import { frontendURL } from 'dashboard/helper/URLHelper.js';
import {
  ENGAGE_VIEW_PERMISSIONS,
  LEGACY_AGENT_ONLY_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import EngagePageRouteView from './pages/EngagePageRouteView.vue';
import EngageTrafficPage from './pages/EngageTrafficPage.vue';
import EngageCampaignsPage from './pages/EngageCampaignsPage.vue';
import EngageGoalsPage from './pages/EngageGoalsPage.vue';

const meta = {
  permissions: {
    anyOf: [
      'administrator',
      LEGACY_AGENT_ONLY_PERMISSIONS,
      ENGAGE_VIEW_PERMISSIONS,
    ],
  },
  hideSecondarySidebar: true,
};

const engageRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/engage'),
      component: EngagePageRouteView,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'engage_traffic_index',
            params: to.params,
          }),
        },
        {
          path: 'traffic',
          name: 'engage_traffic_index',
          meta,
          component: EngageTrafficPage,
        },
        {
          path: 'campaigns',
          name: 'engage_campaigns_index',
          meta,
          component: EngageCampaignsPage,
        },
        {
          path: 'goals',
          name: 'engage_goals_index',
          meta,
          component: EngageGoalsPage,
        },
      ],
    },
  ],
};

export default engageRoutes;
